import React from 'react';

function Heading6({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <path d="M 3 6, v 12" />
      <path d="M 3.5 12, h 8" />
      <path d="M 12 6, v 12" />
      <path d="M17 16C16.7151 14.2747 16.9021 12.7152 17.4984 11.7834C18.0947 10.8516 19.7158 10.671 20.7146 11.7834" />
      <circle cx="19" cy="16" r="2" />
    </svg>
  );
}

export default Heading6;
